import EnterFreespins from "slotworks/state-machine/standard/states/enter-freespins";
import Layers from "slotworks/graphics/layers/layers";
import * as TweenJS from "slotworks/utils/tween";
import gameState from "slotworks/model/game-state";
import translations from "slotworks/i18n/translations";
import Components from "slotworks/components/components";
import CelebrateScatterCommand from "commands/celebrate-scatter-command";
import Contract from "slotworks/utils/contract";
import { sequence, parallel } from "slotworks/utils/race-utils";
import { FadeSymbolsCommand, RestoreSymbolsCommand } from "commands/symbols-commands";
import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import { LOW_SYMBOLS } from "./low-to-high";
import deviceInfo from "slotworks/utils/device-info";
import soundManager from "slotworks/sound/sound-manager";
import ShowWins from "./show-wins";
import regulation from "slotworks/integration/revolver/regulations/regulation";
import smartButton, { SmartButtonFlag } from "slotworks/smart-button/smart-button";
import canvasManager, { Orientation } from "slotworks/graphics/canvas/canvas-manager";
import MessagesComponent from "components/messages/messages-component";

export default class G288EnterFreespins extends EnterFreespins {

    public onEnter() {
        const record = gameState.getCurrentGame().getCurrentRecord();
        const orientationString = canvasManager.orientation == Orientation.PORTRAIT ? "#portrait" : "#landscape";
        const fselement = document.querySelector(`${orientationString} #Background #freespins`) as HTMLElement;
        fselement.style.removeProperty("transition");
        sequence([
            () => FadeSymbolsCommand(Components.matrix.getAllSymbols(), "SCATTER"),
            () => Contract.getTimeoutContract(100),
            () => new Contract(resolve => {
                if(record.freespinsTriggered && record.results.length == 1) {
                    parallel([
                        () => Components.celebrateWin.additionalWin(record.creditsWon),
                        () => CelebrateScatterCommand()
                    ]).then(resolve);
                } else {
                    CelebrateScatterCommand().then(resolve);
                }
            })
        ])
        .then(() => {
            if(!deviceInfo.isDesktop) Layers.SmartButton.hide();

            if(record.freespinsTriggered && record.results.length == 1) {
                Components.celebrateWin.hide();
                Components.betBar.winnings.setWinnings(record.creditsWon, gameState.getCurrentGame().totalCreditsWon, ShowWins.WIN_TICK_TIME);
                regulation.updateNetPosition(gameState.getNetPosition());
            }

            super.onEnter();
            RestoreSymbolsCommand(Components.matrix.getAllSymbols());
        });
    }

    protected showPrompt(scenes: string[] = ["freespinswin", "freespins"], contents?: Map<string, string>) {
        const record = gameState.getCurrentGame().getCurrentRecord();

        if (!contents) {
            contents = new Map<string, string>();
        }

        contents.set("winMessage", translations.get("fs.tri", {VALUE: record.freespinsWon}));
        contents.set("value", record.freespinsWon.toString());
        
        Layers.CelebrationBackground.setScene("freespins").execute();
        
        Layers.Prompts.onSceneEnter.addOnce(() => {
            
        });
        Components.prompt.show(scenes, contents).then(() => {             
            Layers.CelebrationBackground.defaultScene().execute();
            this.complete()
        });
        this.changeScattersToLow();
        Layers.Prompts.onSceneExit.addOnce(() => { 
            smartButton.setFlag(SmartButtonFlag.PROMPT, false);
            this.fadeBetBarIn(); 
            Components.banner.setMode("freespins");
        });
        Layers.Background.setScene("freespins").execute();
        this.fadeBetBarOut();
    }

    public complete() {
        if (Layers.Header.hasScene("freespins")) {
            Layers.Header.setScene("freespins").execute();
        }
        soundManager.customEvent("base_music");
        Layers.SmartButton.show();
        (Components.footer as MessagesComponent).onEnterFreespins();
        super.complete();
    }

    private changeScattersToLow() {
        Components.matrix.getAllSymbols()
        .filter((sym: SymbolComponent) => sym.symbolId == "SCATTER")
        .forEach((sym: SymbolComponent) => {
            sym.setSymbol(LOW_SYMBOLS[Math.floor(Math.random() * LOW_SYMBOLS.length)]);
            sym.updateTransform();
        });
    }

    private fadeBetBarOut() {
        if(!deviceInfo.isDesktop) {
            Layers.SmartButton.hide();
            return;
        }
        const obj = { alpha: 1 }
        new TweenJS.Tween(obj)
        .to({alpha: 0}, 300)
        .onUpdate(() => {
            Layers.BetBar.container.alpha = obj.alpha;
            Layers.SmartButton.container.alpha = obj.alpha;
        })
        .start();
    }

    private fadeBetBarIn() {
        if(!deviceInfo.isDesktop) {
            Layers.SmartButton.show();
            return;
        }
        const obj = { alpha: 0 }
        new TweenJS.Tween(obj)
        .to({alpha: 1}, 300)
        .onUpdate(() => {
            Layers.BetBar.container.alpha = obj.alpha;
            Layers.SmartButton.container.alpha = obj.alpha;
        })
        .start();
    }

}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/states/enter-freespins.ts